export const AppRoles = [
  "Super_Admin",
  "District_Admin",
  "Parent",
  "Teacher",
  "Student",
  "Attendance_coordinator",
  "Clerk",
];

export const IS_Status = {
  IS_Requested: "IS Requested",
};
export const getStatusesData = (duration?: number) => {
  const statusesData: Record<
    string,
    { title: string; description: string; color: string; duration?: string }
  > = {
    ...(duration && duration >= 10
      ? {
          Principal_Approval: {
            title: "IS Requested",
            description: "A new IS request has been submitted.",
            color: "#fbbf24", // yellow
          },
          LEA_Approval: {
            title: "Principal Approved",
            description: "Principal has approved the IS request.",
            color: "#10b981", // green
          },
        }
      : {}),

    ...(duration && duration >= 10
      ? {
          IS_Requested: {
            title: "LEA Approved",
            description: "LEA has approved the IS request.",
            color: "#3b82f6", // blue
          },
        }
      : {
          IS_Requested: {
            title: "IS Requested",
            description: "A new IS request has been submitted.",
            color: "#fbbf24", // yellow
          },
        }),
    StudentReview: {
      title: "IS Assigned",
      description: "Objectives have been assigned.",
      color: "#14b8a6", // teal
    },
    UnderReview: {
      title: "IS Under Review",
      description: "Student has completed the given objectives.",
      color: "#f59e0b", // amber
    },
    AttendanceCoordinatorReview: {
      title: "IS Completed",
      description: "Teacher has reviewed the completion of the study plan.",
      color: "#ef4444", // red
    },
    LEAReview: {
      title: "IS Verified",
      description: "Attendance Coordinator has verified the completion.",
      color: "#9ca3af", // gray
    },
    Completed: {
      title: "ADA Completed",
      description: "ADA recovered successfully.",
      color: "#22c55e", // green
    },
  };
  return statusesData;
};
